import { Component, Inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LeapStaffRole, OrbitRoleMapHistoryEntry } from '../../_models/admin/staff-sync.models';
import { StaffSyncService } from '../../_services/staff-sync/staff-sync.service';
import { AdminEmailComponent } from '../../shared/admin-ux/admin-email.component';

export interface OrbitRoleMapHistoryData {
  orbitRoleName: string;
  leapRoles: LeapStaffRole[];
}

/** The change history of one Orbit role's mapping (latest 50, newest first), as a right-hand drawer. */
@Component({
  selector: 'orbit-role-map-history-drawer',
  standalone: true,
  imports: [DatePipe, AdminEmailComponent],
  templateUrl: 'orbit-role-map-history-drawer.component.html'
})
export class OrbitRoleMapHistoryDrawerComponent implements OnInit {

  public rows: OrbitRoleMapHistoryEntry[] = [];
  public loading = false;
  public error: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: OrbitRoleMapHistoryData,
    private dialogRef: MatDialogRef<OrbitRoleMapHistoryDrawerComponent>,
    private service: StaffSyncService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.service.getRoleMapHistory(this.data.orbitRoleName).subscribe({
      next: rows => {
        this.loading = false;
        this.rows = rows || [];
      },
      error: error => {
        this.loading = false;
        this.error = (error && error.message) || 'Could not load the history.';
      }
    });
  }

  public describeBefore(row: OrbitRoleMapHistoryEntry): string {
    return row.wasMapped ? this.describe(row.beforeLeapRoleCode) : 'Not mapped';
  }

  /** One code or several, comma-separated, by name; null or empty is no TM access. */
  public describe(codes: string | null): string {
    const list = (codes || '').split(',').map(c => c.trim()).filter(c => c.length > 0);
    if (list.length === 0) {
      return 'No TM access';
    }
    return list.map(code => {
      const role = (this.data.leapRoles || []).find(r => r.code === code);
      return role ? role.description + ' (' + code + ')' : code;
    }).join(', ');
  }

  public close(): void {
    this.dialogRef.close();
  }
}
